import { types } from "../types/types";

const initialState = {
  suscripcion: {},
  empresaSuscripcion: null,
  profesionalesActivos: 1,
  tarjeta: null,
};

export const suscripcionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.suscripcionLoad:
      return {
        ...state,
        suscripcion: action.payload,
      };

    case types.suscripcionUpdated:
      return {
        ...state,
        suscripcion: action.payload,
      };

    case types.empresaSuscripcionLoaded:
      return {
        ...state,
        empresaSuscripcion: action.payload,
      };

    case types.profesionalesActivosSet:
      return {
        ...state,
        profesionalesActivos: action.payload,
      };

    case types.tarjetaSet:
      return {
        ...state,
        tarjeta: action.payload,
      };

    default:
      return state;
  }
};
